var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"style-menu"},[_c('MenuHeader',{attrs:{"title":"风格"}}),_c('a-input-search',{staticClass:"input",attrs:{"placeholder":"请输入搜索关键字"},on:{"search":_vm.onSearch}}),_c('MaterialStyleList',{attrs:{"dataList":_vm.dataList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }